export const version = '1.9.1';
//# sourceMappingURL=version.js.map